import * as Yup from 'yup';
import mapValues from 'lodash/mapValues';
import { REQUIRED_ERROR_MSG } from 'utils/constants/errors';

export const workoutsLogSchema = Yup.object().shape({
  currentSets: Yup.array().of(
    Yup.lazy(obj =>
      Yup.object(
        mapValues(obj, (value, key) => {
          return Yup.object().shape({
            weight: Yup.number().required(REQUIRED_ERROR_MSG),
            reps: Yup.number().integer("Must be integer!").required(REQUIRED_ERROR_MSG)
          });
        })
      )
    )
  )
});
